import React, { useCallback } from 'react';
import { ButtonSecondary } from 'components';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { lookupState } from 'state/atoms';
import ReplayIcon from '@material-ui/icons/Replay';

export const StartOver = () => {
  const { lookupResults } = useRecoilValue(lookupState);
  const resetLookupState = useResetRecoilState(lookupState);

  const startOver = useCallback(() => {
    resetLookupState();
  }, [resetLookupState]);

  if (!lookupResults.length) {
    return null;
  }

  return (
    <ButtonSecondary onClick={startOver}>
      <ReplayIcon />
      Start Over
    </ButtonSecondary>
  );
};

export default StartOver;
